import React, { Fragment, ReactElement } from 'react';
import TranslatedText from 'components/atoms/translated_text';
import { Translations } from './configuration';
import { Button, Typography } from '@material-ui/core';
import useStyles from './styles';
import AddIcon from '@material-ui/icons/Add';
import DatatableList from './components/datatable';
import { useDispatch } from 'react-redux';
import ModalActions from 'redux/reducers/gl_modal_reducer/actions';
import { ModalIDs } from 'redux/reducers/gl_modal_reducer/types';
import * as VatReturnDetailsSelectors from 'redux/reducers/vatReturn_detail_reducer/selectors';
import { ReducerKeys } from 'redux/reducers';
import VatReturnDetailActions from 'redux/reducers/vatReturn_detail_reducer/actions';
import { StateStatus } from 'redux/utils/common';

interface IMscon {
  vat_return_version_id: number;
  country_id: number;
  country: string;
  grand_total: number;
  total_msid_goods: number;
  total_msid_services: number;
  total_msest_goods: number;
  total_msest_services: number;
  due_balance: number;
  total_correction: number;
  total_amount_due: number;
}

interface IProps {
  // mode: 'VIEW' | 'EDIT';
  data: Array<IMscon>;
}

export default function BalanceVatDueForEachMemberState(
  props: IProps
): ReactElement {
  console.log('Render BalanceVatDueForEachMemberState');
  // const mode = props.mode;
  const classes = useStyles();
  const dispatch = useDispatch();

  // const result = VatReturnDetailsSelectors.useGetVatCorrections();
  // const countries = VatReturnDetailsSelectors.useGetCountriesWithVatRate();
  return (
    <Fragment>
      <div className={classes.header_container}>
        <Typography variant="h5" style={{ marginBottom: '.5rem' }}>
          <TranslatedText textMap={Translations.header} />
        </Typography>
        <span>
          <TranslatedText textMap={Translations.subtitle} />
        </span>
      </div>
      <DatatableList data={props.data ?? []} />
    </Fragment>
  );
}
